import xhr from './../../utils/xhr';

const api = {
    get: (filters = { indexTerm: null, payload: null }, sorting = {
        sortBy: "createdDate",
        direction: "DESC"
    }, pagination = {pageSize: -1, pageNumber: -1}) => {
        return xhr.post({
            url: `/api/articles/indexTerm/${filters.indexTerm}?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}`,
            data: filters.payload
        });
    },

    count: (filters = {pestle: null, entityId: null,  payload: null}) => {
        return xhr.post({
            url: `/api/articles/count/indexTerm/${filters.indexTerm}`,
            data: filters.payload
        });
    }
}

export default api;



// WEBPACK FOOTER //
// ./src/scripts/pages/TrendingTerms/TrendingTerms.api.js